import { useOrganizations } from "@api/organization.api";
import { CheckIcon } from "@icons";
import { useOrganizationContext } from "@state/organizationContext";
import { FC } from "react";
import { Dropdown } from "react-bootstrap";
import styles from "./OrganizationSwitcher.module.scss";

export const OrganizationSwitcher: FC = () => {
    const { data: organizations } = useOrganizations();
    const { changeActiveOrganization, activeOrganization } =
        useOrganizationContext();

    if (!organizations) {
        return null;
    }

    return (
        <>
            <Dropdown.Header>Organizations</Dropdown.Header>
            <Dropdown.Item
                onClick={() => changeActiveOrganization(null)}
                className={styles.item}
            >
                Personal{" "}
                {activeOrganization === null ? (
                    <CheckIcon className="icon-color-blue-700" />
                ) : null}
            </Dropdown.Item>
            {organizations.map((organization) => (
                <Dropdown.Item
                    key={organization.id}
                    onClick={() => changeActiveOrganization(organization)}
                    className={styles.item}
                >
                    {organization.name}
                    {activeOrganization?.id === organization.id ? (
                        <CheckIcon className="icon-color-blue-700" />
                    ) : null}
                </Dropdown.Item>
            ))}
        </>
    );
};
